import styled from 'styled-components';
import { SystemIconsEraser } from '@elfsight/icons';
import { Button } from '@elfsight/widget-ui';
import { createReadableClass, getColorWithAlpha } from '@elfsight/widget-utils';
import { useLingui } from '@lingui/react/macro';

interface SignatureClearButtonProps {
  color: string;
  isShowButton: boolean;
  isDrawing: boolean;
  fieldBorderRadius: string;
  onClick: () => void;
}

export const SignatureClearButton = ({
  color,
  onClick,
  isShowButton,
  isDrawing,
  fieldBorderRadius
}: SignatureClearButtonProps) => {
  const { t } = useLingui();
  const isRounded = Number(fieldBorderRadius) > 14;

  return (
    <StyledButton
      verticalPadding={4}
      horizontalPadding={8}
      borderRadius={8}
      overlayOpacityOnHover={0}
      borderWidth={1}
      mode="outline"
      variants={{
        initial: {
          color: getColorWithAlpha(color, 0.5),
          borderColor: getColorWithAlpha(color, 0.3),
          backgroundColor: 'transparent'
        },
        hover: {
          color,
          borderColor: color
        },
        focus: {
          color,
          borderColor: color
        }
      }}
      iconLeft={SystemIconsEraser}
      onClick={onClick}
      _isShowButton={isShowButton}
      _isDrawing={isDrawing}
      _isRounded={isRounded}
    >
      {t`Clear`}
    </StyledButton>
  );
};

const StyledButton = styled(Button).attrs({
  className: createReadableClass({
    component: 'signature',
    element: 'clear-button'
  })
})<{ _isShowButton: boolean; _isDrawing: boolean; _isRounded: boolean }>`
  position: absolute;
  right: ${({ _isRounded }) => (_isRounded ? 16 : 8)}px;
  top: ${({ _isRounded }) => (_isRounded ? 16 : 8)}px;
  height: auto;
  opacity: ${({ _isShowButton }) => (_isShowButton ? 1 : 0)};
  pointer-events: ${({ _isDrawing }) => (_isDrawing ? 'none' : 'auto')};
  transition: opacity 0.3s ease;
`;
